import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Pagination } from 'src/app/models/Pagination';
import { AsyncPaginatorData } from '../../classes/AsyncPaginatorData';

@Component({
	selector: 'app-async-simple-paginator',
	templateUrl: './async-simple-paginator.component.html',
	styleUrls: ['./async-simple-paginator.component.scss']
})
export class AsyncSimplePaginatorComponent {

	// Este paginador está desconectado de la tabla que muestra los datos
	// Está para emitir datos sobre la posición del paginado y agarrarlos en el componente y consultar como corresponda
	// Todos los inputs y outputs son obligatorios
	// A diferencia del otro, este paginador no cambia el tamaño de la página. Solo devuelve lo que ya tiene el objeto pagination

	@Input() pagination! : Pagination<any>;
	@Input() bLoading! : boolean;
	@Input() wrapper_classes! : string;
	@Output() eePageChange = new EventEmitter<AsyncPaginatorData>();

	previous() {
		let apd = new AsyncPaginatorData(this.pagination.current_page-1, this.pagination.per_page);
		this.eePageChange.emit(apd);
	}
	next() {
		let apd = new AsyncPaginatorData(this.pagination.current_page+1, this.pagination.per_page);
		this.eePageChange.emit(apd);
	}
}